module.exports = __webpack_public_path__ + "static/media/wps2.png.0c46508e.jpg";